import { collection, doc, getDoc } from "firebase/firestore"

import { CLIENT_COLLECTION } from "../../../const"
import { auth } from "../auth"
import { db } from "../index"

import { HttpsCallableFactory } from "./functions"

import type { Client, ClientUpsert } from "interfaces/ClientIF"

const hcf = new HttpsCallableFactory("client")

export const getClient = async () => {
  const uuid = auth.currentUser?.uid
  const clientCollection = collection(db, CLIENT_COLLECTION)
  const res = await getDoc(doc(clientCollection, uuid))

  if (!res.exists()) {
    throw new Error("ログイン中のユーザのプロフィールは存在しません")
  }
  return res.data() as Client
}

export const getClientProfile = getClient

export const upsertClientProfile = hcf.callFunction<ClientUpsert, void>(
  "upsertProfile",
)
